const loadScript = (path: string): void => {
  const scriptEl = document.createElement('script');
  scriptEl.src = path;
  document.getElementsByTagName('head')[0].appendChild(scriptEl);
};

export { loadScript };
